module.exports = __webpack_public_path__ + "static/img/bg-1.d46f6b32.webp";